import classNames from 'classnames'

export default function ModalBackground({
	show,
	className,
	onClose = () => {
		{
		}
	},
}: {
	show: boolean
	onClose?: any
	className?: string
}) {
	return (
		<div
			onClick={() => onClose()}
			className={classNames(
				'bg-black opacity-50 fixed top-0 left-0 w-full h-full duration-500 transition-all ',
				className,
				{ 'opacity-0 -z-10': !show },
				{ 'z-[15]': show },
			)}
		/>
	)
}
